// Sample editorial pieces for the Insights section. Each article uses an
// SEO-friendly slug, German metadata and structured paragraphs.

export const insights = [
  {
    slug: "unternehmensnachfolge-im-mittelstand",
    title:
      "Unternehmensnachfolge im Mittelstand: Strukturen, die langfristig tragen",
    excerpt:
      "Warum eine sorgfältig vorbereitete Nachfolge nicht nur eine Frage des Preises, sondern vor allem eine Frage der Verantwortung, der Struktur und der gemeinsamen Werte ist.",
    category: "Unternehmensnachfolge",
    readingTime: "6 Min.",
    date: "2026-09-12",
    image:
      "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80",
    body: [
      "Unternehmensnachfolge ist in den nächsten Jahren eine der zentralen wirtschaftlichen Herausforderungen für den deutschen Mittelstand. Tausende Unternehmen werden den Übergang in eine neue Eigentümergeneration vollziehen müssen – oft unter Zeitdruck und ohne klar vorbereitete Struktur.",
      "Aus unserer Sicht ist eine erfolgreiche Nachfolge zuerst eine Frage der Haltung: Wer übernimmt das Lebenswerk? Mit welchen Werten? Mit welcher Perspektive für Mitarbeitende, Kunden und Standort? Erst danach folgen Bewertung, Vertragsstruktur und Finanzierung.",
      "Eine unternehmerisch geprägte Beteiligungsgesellschaft kann hier eine glaubwürdige Alternative zu klassischen Finanzinvestoren bieten: kein fester Exit-Horizont, kein renditegetriebenes Druckmodell, sondern langfristige Verantwortung kombiniert mit professioneller Struktur.",
      "Wagenhofer Capital begleitet Inhaberinnen und Inhaber in solchen Übergangsphasen – diskret, strukturiert und mit klarem Fokus auf Substanz und Stabilität.",
    ],
  },
  {
    slug: "holding-strukturen-effizient-gestalten",
    title:
      "Holdingstrukturen effizient gestalten: Klarheit als unternehmerischer Hebel",
    excerpt:
      "Eine durchdachte Holdingstruktur ist mehr als ein steuerliches Konstrukt – sie ist Voraussetzung für Skalierbarkeit, Governance und langfristige Werteentwicklung.",
    category: "Holdingstrukturen",
    readingTime: "5 Min.",
    date: "2026-08-21",
    image:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1600&q=80",
    body: [
      "Eine professionell aufgesetzte Holdingstruktur schafft die Grundlage für klare Verantwortlichkeiten, saubere Beteiligungsverhältnisse und langfristige Werteentwicklung. Sie ist weniger ein Selbstzweck als ein Werkzeug, das unternehmerisches Handeln ermöglicht.",
      "Drei Dimensionen sind dabei entscheidend: erstens die rechtliche Ordnung (Beteiligungen, Stimmrechte, Vertretung), zweitens die ökonomische Logik (Ergebnisflüsse, Finanzierung, Risikotragung) und drittens die operative Steuerung (Management, Reporting, Governance).",
      "Wer diese drei Ebenen aufeinander abstimmt, gewinnt Handlungsspielraum – und kann Wachstum, Beteiligungen oder Nachfolgen deutlich strukturierter und ruhiger umsetzen.",
      "Wagenhofer Capital arbeitet konsequent in einer klaren Dachstruktur und sieht darin einen wesentlichen Beitrag zu unternehmerischer Stabilität.",
    ],
  },
  {
    slug: "immobilieninvestments-im-raum-muenchen",
    title:
      "Immobilieninvestments im Raum München: Lage, Nutzung, Verantwortung",
    excerpt:
      "Der Münchner Markt belohnt strategische Geduld. Welche Kriterien wir bei Standort- und Nutzungskonzepten anlegen.",
    category: "Immobilieninvestments",
    readingTime: "5 Min.",
    date: "2026-07-04",
    image:
      "https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=1600&q=80",
    body: [
      "Der Raum München zählt zu den nachhaltig stabilsten Immobilienmärkten Europas. Diese Stabilität ist kein Zufall, sondern Resultat aus wirtschaftlicher Stärke, qualifizierter Bevölkerung und disziplinierter Stadtentwicklung.",
      "Wir bewerten Immobilien- und Standortprojekte aus drei Perspektiven: städtebauliche Substanz, Nutzungsperspektive sowie wirtschaftliche Tragfähigkeit über die kommenden Dekaden. Kurzfristige Zyklen sind dabei zweitrangig.",
      "Besonders interessant sind für uns Projekte mit gastronomischer, gewerblicher oder gemischter Nutzung – dort entstehen Wertbeiträge nicht allein durch Lage, sondern durch Betreiberkompetenz und Konzeptklarheit.",
      "Wagenhofer Capital prüft solche Projekte in enger Abstimmung mit Eigentümern, Vermietern und Projektpartnern.",
    ],
  },
  {
    slug: "warum-langfristigkeit-wieder-wertvoll-wird",
    title:
      "Warum Langfristigkeit wieder wertvoll wird – Plädoyer für unternehmerische Geduld",
    excerpt:
      "In einem Markt, der sich permanent neu beschleunigt, wird Geduld zum strategischen Vorteil. Über Substanz statt Symbolik.",
    category: "Unternehmertum",
    readingTime: "4 Min.",
    date: "2026-05-18",
    image:
      "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1600&q=80",
    body: [
      "Märkte beschleunigen, Zyklen verkürzen sich, Erwartungen steigen. In einem solchen Umfeld bekommt Langfristigkeit eine neue Qualität: Sie ist nicht mehr Standard, sondern Differenzierungsmerkmal.",
      "Unternehmen, die in Jahrzehnten denken, sind besser in der Lage, Krisen auszuhalten, Mitarbeitende zu binden, Lieferanten verlässlich zu vergüten und Kunden tatsächlich Vertrauen zu schenken.",
      "Für eine Beteiligungsgesellschaft bedeutet das konkret: kein Druck zu vorzeitigen Exits, kein renditegetriebenes Hochfrequenz-Modell, sondern bewusster Aufbau von Substanz – mit allen damit verbundenen Pflichten.",
      "Wagenhofer Capital sieht in dieser Haltung einen ökonomischen wie ethischen Vorteil.",
    ],
  },
];

export function getInsightBySlug(slug) {
  return insights.find((i) => i.slug === slug) || null;
}
